import { Fragment, useState } from "react";
import { sentenceCase } from "change-case-all";
import { useNavigate } from "react-router-dom";
import { Grid, Typography } from "@mui/material";

import pages from "../../../constants/pages";
import { Paper } from "../../../components";
import ShowAudienceSizeDialog from "./ShowAudienceSize";
import { ActiveTextEighteen, colors } from "../../css components/Style";

export default function AdminCampaignStatus({
  preferredChannels,
  audienceSize,
  formikProps,
  isDisabled,
  channelSectionRef,
  scrollToChannelSection,
  setForceClick,
}) {
  const navigate = useNavigate();
  const [showAudSize, setShowAudSize] = useState();

  return (
    <Fragment>
      {preferredChannels.length === 0 && (
        <Paper style={{ background: colors.hoverBlue }}>
          <Grid size={12} textAlign={"center"} display={"flex"}>
            <Typography variant="h5" style={{ color: colors.warning }}>
              Please add channel agents before creating campaign. &nbsp;
            </Typography>
            <Typography
              variant="h5"
              color={colors.info}
              style={{ cursor: "pointer" }}
              onClick={() => navigate(pages.channelAgentSettingPage.route)}
            >
              Add Agents
            </Typography>{" "}
          </Grid>
        </Paper>
      )}
      {!!formikProps.values.campaignID && (
        <Paper style={{ background: colors.hoverBlue, padding: "15px" }}>
          <Grid size={12}>
            <Typography
              variant="h5"
              style={{
                color: displayStatusColor(),
              }}
            >
              {sentenceCase(formikProps.values.displayStatus)}
            </Typography>
          </Grid>

          {!!(
            audienceSize?.values?.audience_params ||
            audienceSize?.values?.audience_size
          ) &&
            formikProps.values.permissionSettings?.consumer_audience_view && (
              <Grid size={12} textAlign={"center"} display={"flex"}>
                <ActiveTextEighteen style={{ color: colors.green }}>
                  Your audience size is ready ! &nbsp;{" "}
                </ActiveTextEighteen>
                <ActiveTextEighteen
                  color={colors.publicisBlue}
                  style={{ cursor: "pointer" }}
                  onClick={() => setShowAudSize(true)}
                >
                  View
                </ActiveTextEighteen>
              </Grid>
            )}

          {!!(
            audienceSize?.values?.audience_params ||
            audienceSize?.values?.audience_size
          ) &&
            formikProps.values.isCampaignLive &&
            formikProps.values.campaignStatus !== "ACTIVE" && (
              <Grid size={12} textAlign={"center"} display={"flex"}>
                <ActiveTextEighteen style={{ color: colors.publicisBlue }}>
                  Request sent for making campaign live.
                </ActiveTextEighteen>
              </Grid>
            )}

          {formikProps.values.campaignStatus === "REQUESTED" &&
            formikProps.values?.isPendingSizing &&
            !formikProps.values?.isPendingSizing &&
            !(audienceSize?.audience_params || audienceSize?.audience_size) && (
              <Grid size={12} textAlign={"center"} display={"flex"}>
                <ActiveTextEighteen style={{ color: colors.warning }}>
                  The request has been raised and is expected to be ready within
                  24 to 72 hours.
                </ActiveTextEighteen>
              </Grid>
            )}

          {formikProps.values.campaignStatus === "REQUESTED" &&
            formikProps.values?.isPendingSizing &&
            !(audienceSize?.audience_params || audienceSize?.audience_size) && (
              <Grid size={12} textAlign={"center"} display={"flex"}>
                <ActiveTextEighteen style={{ color: colors.warning }}>
                  The process is taking longer than expected. Please contact the
                  admin.
                </ActiveTextEighteen>
              </Grid>
            )}

          {formikProps.values.status === "CREATED" &&
            formikProps.values.adminApprovalStatus === "ACCEPTED" &&
            formikProps.values?.isPendingSizing &&
            (!audienceSize?.values?.audience_params ||
              !audienceSize?.values?.audience_size) && (
              <Grid size={12}>
                <Typography variant="h6" color={colors.warning}>
                  The campaign request has been approved by the admin team, and
                  the audience size is expected to be finalized within 24 to 72
                  hours.
                </Typography>
              </Grid>
            )}

          {formikProps.values.displayStatus === "CREATED" && (
            <Grid size={12}>
              <Typography variant="h6" color={colors.publicisBlue}>
                If you are confident about your campaign details, you can send
                it for approval.
              </Typography>
            </Grid>
          )}

          {formikProps.values.displayStatus === "Expired" &&
            formikProps.values.isEditable && (
              <Grid size={12}>
                <Typography variant="h6" color={colors.publicisBlue}>
                  You can update the campaign’s start date anytime to continue
                  using this campaign.
                </Typography>
              </Grid>
            )}

          {formikProps.values.adminApprovalStatus === "REQUESTED" && (
            <Grid size={12}>
              <Typography variant="h6" color={colors.publicisBlue}>
                Your campaign has been sent for admin approval.
              </Typography>
            </Grid>
          )}
        </Paper>
      )}
      <ShowAudienceSizeDialog
        formikProps={formikProps}
        audienceSize={audienceSize}
        showAudSize={showAudSize}
        isDisabled={isDisabled}
        setShowAudSize={setShowAudSize}
        channelSectionRef={channelSectionRef}
        setForceClick={setForceClick}
        scrollToChannelSection={scrollToChannelSection}
      />
    </Fragment>
  );

  function displayStatusColor() {
    let color = "";
    if (
      formikProps.values.displayStatus === "CREATED" ||
      formikProps.values.displayStatus === "DRAFT"
    ) {
      color = "#37474F";
    }

    if (formikProps.values.displayStatus === "Approval Requested") {
      color = "#E65100";
    }

    if (formikProps.values.displayStatus === "Sizing in Progress") {
      color = "#1565C0";
    }

    if (formikProps.values.displayStatus === "Size Ready") {
      color = "#512DA8";
    }

    if (formikProps.values.displayStatus === "Go-Live Requested") {
      color = "#F9A825";
    }

    if (formikProps.values.displayStatus === "ACTIVE") {
      color = "#2E7D32";
    }

    if (formikProps.values.displayStatus === "REJECTED") {
      color = "#C62828";
    }

    if (formikProps.values.displayStatus === "Expired") {
      color = "#C62828";
    }

    return color;
  }
}
